import type { SSRErrorResponseProps } from '@gik/core/api/BaseAPIConfig';
import { ErrorPage } from '@gik/core/pages/Error/ErrorPage';
import { NotFoundPage } from '@gik/core/pages/NotFound/NotFoundPage';
import { InkindDeactivatedPage } from '@gik/inkind-page/pages/InkindDeactivatedPage/InkindDeactivatedPage';
import HttpStatus from 'http-status-codes';
import React from 'react';
import { PageLayout } from './layout/PageLayout';

export type StatusCodeHandlerProps = {} & SSRErrorResponseProps;

export function StatusCodeHandler({
  statusCode,
  error,
}: React.PropsWithChildren<StatusCodeHandlerProps>): React.ReactElement {
  return (
    <PageLayout>
      {statusCode === HttpStatus.NOT_FOUND ? (
        <NotFoundPage />
      ) : statusCode === HttpStatus.GONE ? (
        // TODO: support other types of GONE pages based on URL
        <InkindDeactivatedPage />
      ) : (
        <ErrorPage statusCode={statusCode} error={error} />
      )}
    </PageLayout>
  );
}
